import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { setForgotPassword } from '@sonifi/wb-user/store//userSlice';
import { forgotPassword } from '@sonifi/wb-user/services/user.service';
import { EMAIL_PATTERN } from '@sonifi/wb-core/common/Constants';

const ForgotPassword = () => {
  const forgotSubmitted = useSelector((state) => state.user.forgotSubmitted);
  const { formState: { isValid }, handleSubmit, register } = useForm();
  const dispatch = useDispatch();

  const hide = useCallback(() => {
    setTimeout(() => {
      dispatch(setForgotPassword(false));
    }, 7000);
  }, [dispatch]);

  if (forgotSubmitted) {
    // After 7secs hide Forgot Password
    hide();
    return (
      <div className="login-container">
        <div className="forgot-submitted">
          {'We\'re here to help! Instructions to reset your password have been sent to your email address.'}
        </div>
      </div>
    );
  }
  const resetPassword = ({ email }) => {
    dispatch(forgotPassword(email));
  };

  const cancel = () => {
    dispatch(setForgotPassword(false));
  };

  return (
    <div className="login-container">
      <div className="forgot">
        <form onSubmit={handleSubmit(resetPassword)}>
          <input
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: EMAIL_PATTERN,
              },
            })}
            id="email"
            placeholder="Email"
            type="text"
            required
          />
          <button type="submit" className="primary" disabled={!isValid}>
            Submit
          </button>
          <button type="button" onClick={cancel}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
